import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AuthBetweenLink from '../../../../Features/AuthBetweenLink/AuthBetweenLink';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './PasswordRecoveryConfirm.module.scss';
import StepTitle from '../../../../Features/StepTitle/StepTitle';
import StepDescription from '../../../../Features/StepDescription/StepDescription';
import { useAppDispatch, useAppSelector } from '../../../../../../config/redux/hooks';
import { recoveryConfirm } from '../../passwordRecoverySlice';
import useNotifyOnError from '../../../../../../common/form/useNotifyOnError';
import PasswordConfirmForm from '../../../../../Features/PasswordConfirmForm/PasswordConfirmForm';
import { useNotification } from '../../../../../Common/Notification/notify';

function PasswordRecoveryConfirm() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigation = useNavigate();
  const { token } = useParams();
  const notify = useNotification();
  const readyToLogin = useAppSelector(state => state.auth.passwordRecovery.readyToLogin);
  const error = useAppSelector(state => state.auth.passwordRecovery.error);

  const onSubmit = useCallback(
    values => {
      if (!token) {
        notify.error(t('common.notification.code.missing'));
        return;
      }
      dispatch(recoveryConfirm({ token, password: values.password }));
    },
    [token],
  );

  useNotifyOnError(error);

  useEffect(() => {
    if (readyToLogin) {
      navigation('/auth/recovery/success');
    }
  }, [readyToLogin]);

  return (
    <div className={styles.container}>
      <StepTitle>{t('recovery.password.confirm.title')}</StepTitle>
      <StepDescription>{t('recovery.password.confirm.description')}</StepDescription>
      <PasswordConfirmForm submitButtonLabel={t('recovery.password.confirm.button')} onSubmit={onSubmit} />
      <AuthBetweenLink title={t('recovery.password.link.title')} link={'/auth/login'} linkText={t('recovery.password.link.text')} />
    </div>
  );
}

export default PasswordRecoveryConfirm;
